import { asyncModule } from '../../utils/async-module';
import { asyncPreactWidget } from '../../utils/async-preact-widget';
import * as JSModules from '../../components/modules';
import * as preactWidgets from '../../preact/widgets';

export const asyncOtherNewsChecker = () => {
  const $element = document.querySelector('.j-other-news');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.otherNewsCheckerModule);
    start();
    import('../../components/other-news/other-news').then(getInit()).catch(error);
  }
};

export const asyncNewsYouCanUse = () => {
  const $element = document.querySelector('.j-news-u-can-use');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.newsYouCanUseModule);
    start();
    import('../../components/news-u-can-use/news-u-can-use').then(getInit($element)).catch(error);
  }
};

export const asyncLatestNews = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.latestNews);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/latest-news`).then(hydrate).catch(error);
  }
};

export const asyncLatestNewsInfinite = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.latestNewsInfinite);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/latest-news-infinite`).then(hydrate).catch(error);
  }
};
